export default __webpack_public_path__ + "static/media/search.f198d927.svg";